import { EiTableRow } from '../models/ei-table.model'
import { paginate } from './ei-table.data.helpers'

/**
 * Normalize page index to ensure it's within valid bounds.
 * Returns the safe page index.
 */
function normalizePageIndex(pageIndex: number, totalPages: number): number {
    const maxPageIndex = Math.max(0, totalPages - 1)
    return Math.max(0, Math.min(pageIndex, maxPageIndex))
}

/**
 * Get paginated rows with normalized page index.
 */
export function getPagedRows(
    rows: EiTableRow[],
    pageIndex: number,
    pageSize: number,
    totalPages: number,
): { rows: EiTableRow[]; normalizedPageIndex: number } {
    const safePageIndex = normalizePageIndex(pageIndex, totalPages)
    return {
        rows: paginate(rows, safePageIndex, pageSize),
        normalizedPageIndex: safePageIndex,
    }
}
